{
  "notifications": {
    "updateReservationFailed": "We were unable to update your reservation. Please try again later.",
    "reservationNotFound": "We were unable to find your reservation. Please try again later.",
    "reservationNotFoundShort": "The reservation was not found. Please try again.",
    "venueBookingFailed": "We're unable to book a reservation for this venue. Please try again later.",
    "confirmMenuItemsFailed": "We were unable to confirm your menu items. Please try again later.",
    "customizationsSavedBody": "Customizations have been saved successfully.",
    "addExternalGuestClientRequired": "Please sign up to Ande as a client to add external guests.",
    "addGuestFailed": "We're unable to add this guest. Please try again later.",
    "requestExpiredTitle": "Request Expired",
    "requestExpiredBody": "The venue request made has expired. Please make a new request to the venue before continuing",
    "requestNotApprovedTitle": "Request Not Approved",
    "requestNotApprovedBody": "This venue requires a request approval before you can book",
    "hostAssignedBody": "Host has been assigned to reservation.",
    "assignHostFailedBody": "Failed to assign host",
    "consolidatedBody": "Reservation has been consolidated to event.",
    "consolidateFailedBody": "Failed to consolidate reservation to event",
    "uploadErrorTitle": "Upload Error",
    "uploadMissingFileBody": "Missing required file information.",
    "uploadNoClientBody": "User does not have a client associated.",
    "uploadVenueNotFoundBody": "Venue information not found.",
    "contractUploadedTitle": "Contract Uploaded",
    "uploadContractFailedBody": "Failed to upload contract. Please try again.",
    "successTitle": "Success!",
    "rewardsEnabledBody": "Your account has been enabled for rewards.",
    "venueNotFoundBody": "Venue not found.",
    "contractSignedTitle": "Contract Signed",
    "eSignContractFailedBody": "Failed to e-sign venue contract. Please try again.",
    "contractIdMissingBody": "Contract ID not provided.",
    "contractRemovedTitle": "Contract Removed",
    "revokeContractFailedBody": "Failed to revoke venue contract. Please try again.",
    "holdPlacedTitle": "Hold Placed",
    "holdPlacedBody": "We've put a hold on your reservation and saved it as a draft. You can close this window and come back once you have the signed contract.",
    "holdPlaceFailedTitle": "Failed to place hold",
    "holdPlaceFailedBody": "We were unable to place a hold on your reservation. Please try again later.",
    "holdCanceledTitle": "Hold Canceled",
    "holdCanceledBody": "Your reservation hold has been canceled successfully.",
    "holdCancelFailedBody": "Failed to cancel hold on reservation.",
    "approvalRequestSubmittedTitle": "Approval Request Submitted",
    "approvalRequestSubmittedBody": "Your booking request has been sent for approval.",
    "procurementSubmitFailedTitle": "Failed to submit procurement request",
    "procurementSubmitFailedBody": "We were unable to submit your procurement request. Please try again later.",
    "reservationErrorTitle": "Reservation Error",
    "reservationCompleteFailedBody": "There was an error completing your reservation",
    "confirmReservationFailedTitle": "Failed to confirm reservation",
    "confirmReservationFailedMessage": "We were unable to book your reservation. Please try again later."
  },
  "editDateModal": {
    "title": "Edit your event date?",
    "body": "Changing the date may affect your venue's availability and selected time slot.",
    "cancel": "Cancel",
    "continueToEventDetails": "Continue to event details →"
  },
  "editReservationModal": {
    "title": "Edit Reservation",
    "nameLabel": "Name",
    "namePlaceholder": "Name",
    "typeLabel": "Type",
    "budgetUsd": "Budget (USD)",
    "budgetHint": "After taxes, fees & gratuity.",
    "budgetPlaceholder": "Any",
    "continue": "Continue",
    "spendAllowance": "Spend Allowance: <bold>{{amount}} pp</bold>",
    "gratuityAllowance": "Gratuity Allowance: <bold>{{percent}}% of the subtotal</bold>"
  },
  "customize": {
    "selectMenusTitle": "Select Menu(s)",
    "minimumSpendHint": "Minimum spend for the room is for the subtotal only. Taxes, fees and gratuity will be applied after the minimum is met.",
    "selectionsModifiableInfo": "All selections can be modified after booking.",
    "totalBeforeFees": "Total before fees & taxes",
    "perPerson": "<strong>{{amount}}</strong> per person",
    "minimumSpendModalTitle": "Minimum Spend not met",
    "minimumSpendModalParagraph1": "The items you've pre-ordered do not meet the minimum spend for this room.",
    "minimumSpendModalParagraph2": "Any outstanding balance can be put towards additional food and beverage items.",
    "minimumSpendModalParagraph3": "Any remaining balance by the end of the night will be added to the tab."
  },
  "customizeActionBar": {
    "continue": "Continue ->",
    "selectLater": "I'll make my selections later ->",
    "makeRequiredSelections": "Make all required selections to continue",
    "completed": "Completed!",
    "selectNowOrLater": "Select now... or later!"
  },
  "guests": {
    "title": "Add Guests",
    "optional": "(optional)",
    "rsvpHintDesktop": "You can trigger RSVP emails from reservation details, after the reservation is confirmed.",
    "searchPlaceholder": "Search by name or email",
    "attendingLabel": "I'm attending",
    "partyFullBadge": "{{current}}/{{total}} guests",
    "guestListFull": "Looks like your guest list is full. To add a different one, please remove one first.",
    "rsvpHintMobile": "RSVP emails will only be sent after the reservation is confirmed",
    "tableGuest": "Guest",
    "tableDietary": "Dietary restrictions",
    "editSrOnly": "Edit",
    "editLink": "Edit",
    "noteForVenuePill": "note for venue",
    "noRestrictions": "No Restrictions",
    "hostPill": "HOST",
    "coordinatorPill": "COORD"
  },
  "confirm": {
    "shortlistEliminated": {
      "title": "You removed this venue",
      "body": "You removed {{venueName}} from your shortlist. Do you want to book it anyway? This will add it back to your shortlist.",
      "bookAnyway": "Book anyway",
      "backToChat": "Back to chat"
    },
    "eventConsolidation": {
      "title": "We have found an existing event",
      "intro": "Looks like you are already working on an event at this date and time. Select one to add this reservation to.",
      "linkPrompt": "Would you like to link this reservation to your selection?",
      "skip": "No, it's a different event",
      "submit": "Yes, link to this event",
      "submitting": "Submitting...",
      "optionCount_one": "{{count}} option",
      "optionCount_other": "{{count}} options"
    },
    "bookingPromotion": {
      "earnEstimated": "You will earn an estimated <bold>{{amount}}</bold> in Ande Credits by completing this reservation.",
      "earnGeneric": "You will earn Ande Credits by completing this reservation.",
      "whatAreCredits": "What are Ande Credits?",
      "tooltip": "For a limited time, Ande is offering a reward of {{percent}}% of your booking at our partner venues. The experience remains premium — the savings are on us."
    },
    "eventReward": {
      "body": "You'll earn <bold>{{amount}}</bold> by completing this reservation."
    },
    "stripeCheckout": {
      "cardOnFileTitle": "Card on File",
      "openTableSecurityNote": "For security reasons, reservations powered by OpenTable need the card information to be manually entered before booking.",
      "openTableAgreement": "By confirming this reservation, you agree to OpenTable's <termsLink>terms and conditions</termsLink>, and <privacyLink>privacy policy</privacyLink>.",
      "opensInNewTab": "Opens in a new tab",
      "processing": "Processing...",
      "confirmReservation": "Confirm Reservation"
    },
    "pageTitleRequest": "Confirm Request",
    "pageTitleReservation": "Confirm Reservation",
    "pricing": {
      "priceDetails": "Price Details",
      "showMore": "Show More",
      "showLess": "Show Less",
      "reservationCharge": "Reservation Charge",
      "subtotal": "Subtotal",
      "subtotalPercentOff": "Subtotal ({{percent}}% OFF)",
      "gratuity": "Gratuity",
      "serviceCharge": "Service Charge",
      "adminFee": "Admin Fee",
      "adminFeePercentOff": "Admin Fee ({{percent}}% OFF)",
      "tax": "Tax",
      "orderTotal": "Order Total",
      "total": "Total",
      "totalWithDiscountOff": "Total ({{discount}} OFF)",
      "orderTotalWithDiscountOff": "Order Total ({{discount}} OFF)",
      "andeBookingFeeDeposit": "Ande Booking Fee ({{percent}}% of the deposit)",
      "andeBookingFee": "Ande Booking Fee ({{percent}}%)",
      "processingFee": "Processing Fee",
      "processingFeePercent": "Processing Fee ({{percent}}%)",
      "processingFeePercentInline": "{{percent}}% Processing Fee",
      "totalDueNow": "Total Due Now",
      "estimatedTotal": "Estimated Total",
      "amount": "Amount",
      "bookingFeePercent": "Booking Fee ({{percent}}%)",
      "dueToday": "Due Today",
      "basedOnOrderIntro": "Based on the order, we are estimating your total bill below:",
      "basedOnMinSpendIntro": "Based on your minimum spend requirement, we are estimating your total bill below:",
      "minimumSpend": "Minimum Spend",
      "orderSubtotal": "Order Subtotal",
      "estimatedSavings": "Estimated Savings",
      "depositDueAtBooking": "Deposit Due at time of booking",
      "deposit": "Deposit",
      "dueAtBooking": "Due at Booking",
      "feeNameAmountOff": "{{name}} ({{amount}} OFF)",
      "estimatedGratuity": "Estimated Gratuity",
      "estimatedServiceCharge": "Estimated Service Charge",
      "estimatedAdminFee": "Estimated Admin Fee",
      "estimatedTax": "Estimated Tax",
      "percentOfTotal": "{{percent}}% of the total",
      "percentOfEstimatedTotal": "{{percent}}% of the estimated total",
      "percentOfBaseMinimumSpend": "{{percent}}% of the base minimum spend",
      "depositPercentOfTotal": "Deposit ({{percent}}% of the total)",
      "depositPercentOfEstimatedTotal": "Deposit ({{percent}}% of the estimated total)",
      "depositPercentOfBaseMinimumSpend": "Deposit ({{percent}}% of the base minimum spend)",
      "estimatedTotalDueOnDate": "Estimated Total due {{date}}",
      "estimatedTotalDueAfterReservationDate": "Estimated Total due after Reservation Date"
    },
    "payments": {
      "paymentMethodTitle": "Payment Method",
      "howToPayTitle": "How would you like to pay?",
      "howToPayBody": "Choose a payment method that allows the venue to charge you after your reservation.",
      "houseAccount": "House Account",
      "reducedFees": "Reduced fees with preferred venues",
      "payAtVenue": "Pay at venue",
      "creditLimitExceeded": "Credit limit exceeded",
      "bankAccountMasked": "Bank Account (***{{lastFour}})",
      "centralBillingAlt": "Central Billing",
      "centralBillingLabel": "{{brand}} Central Billing",
      "cardAlt": "Card",
      "achTransfer": "ACH (Bank Transfer)",
      "creditCard": "Credit Card",
      "add": "Add",
      "selectPaymentMethod": "Select a payment method",
      "postReservationChargeNote": "We'll use this payment method for any charges after the reservation.",
      "bookingUnavailableTitle": "Booking is currently unavailable",
      "bookingUnavailableBody": "This booking can't be confirmed while an approval is pending.",
      "testMode": "Test Mode",
      "submitForApproval": "Submit for Approval",
      "payNow": "Pay Now",
      "payDeposit": "Pay Deposit - {{amount}}",
      "processing": "Processing...",
      "eventDetailsAcknowledgment": "By clicking this button you are acknowledging the Event Details.",
      "waivedProcessingFees": "Waived Processing Fees",
      "corporateBenefitsTitle": "Corporate Benefits Savings",
      "corporateBenefitsDeposit": "You're estimated to save {{amount}} on this booking ({{percent}}%). Savings will be applied at the final payment.",
      "corporateBenefitsNoDeposit": "You're saving {{amount}} on this booking ({{percent}}%).",
      "payNowAndConfirm": "Pay Now & Confirm Reservation",
      "confirmReservation": "Confirm Reservation",
      "agreeToCancellationPolicy": "I Agree to the <policyLink>Cancellation Policy</policyLink> for this reservation.",
      "agreeToMinimumSpendCard": "I Agree to my card being saved on file for any additional charges, including payment of the required <minimumSpendLink>Minimum Spend</minimumSpendLink> for this reservation.",
      "agreeToMinimumSpendPayment": "I Agree to my payment method being saved on file for any additional charges, including payment of the required <minimumSpendLink>Minimum Spend</minimumSpendLink> for this reservation."
    },
    "host": {
      "whosHosting": "Who's hosting?",
      "nameOnReservation": "This name will appear on the reservation.",
      "partySizeTooSmall": "Your Party size is too small to add a host. Adjust your party size to enable this.",
      "changeHost": "Change Host",
      "holdHostLockedTooltip": "The host can't be changed as the name has already been added to the reservation hold.",
      "duplicateHostError": "There is already an existing reservation at the venue under this name",
      "changeHostModalTitle": "Change Host",
      "searchPlaceholder": "Search by name or email",
      "customHostDetailsTitle": "Custom Host Details",
      "firstNamePlaceholder": "First Name",
      "lastNamePlaceholder": "Last Name",
      "emailPlaceholder": "Email Address",
      "phonePlaceholder": "Phone Number",
      "hostReceiveEmailsLabel": "Host receives reservation emails",
      "hostReceiveEmailsHint": "When disabled, the host will not receive any email communications about this reservation.",
      "save": "Save"
    },
    "foodAndBeverage": {
      "title": "Food and Beverage",
      "requestFlowBody": "The venue will communicate any additional menu needs via chat or email.",
      "viewMenuOptions": "View Menu Options",
      "andeFlowBody": "The venue will work with you to build your menus leading up to your reservation.",
      "menuOptionsModalTitle": "Menu Options"
    },
    "gratuity": {
      "title": "Gratuity",
      "selectForTotalBill": "Select a percentage for the <bold>total bill</bold>.",
      "houseAccountMinimum": "A {{percent}}% minimum gratuity applies when you pay using a House Account.",
      "venueMinimum": "{{venueName}} has an {{percent}}% minimum gratuity for this reservation."
    },
    "cardOnFile": {
      "title": "Card on File",
      "depositOrCancellationNote": "This venue requires a credit card to book because this reservation requires a deposit, or may have a cancellation fee."
    },
    "documents": {
      "title": "Documents",
      "untitled": "Untitled Document",
      "view": "View"
    },
    "eventDocumentType": {
      "CONTRACT": "Contract",
      "MENU": "Menu",
      "BEVERAGE": "Beverage",
      "WINE": "Wine",
      "EVENT": "Event",
      "RECEIPT": "Receipt",
      "COI": "Certificate of Insurance",
      "PAYLINK": "Paylink"
    },
    "contract": {
      "filename": "Contract",
      "signed": "Signed",
      "reviewAndSign": "Review & Sign",
      "signedStatus": "SIGNED",
      "notSignedStatus": "NOT SIGNED"
    },
    "paymentPending": {
      "body": "This reservation cannot be confirmed yet. A payment request has not been created."
    },
    "duplicateEventBooking": {
      "line1": "You've already confirmed a different booking for this event.",
      "line2": "Please reach out to Ande support if you think this is a mistake."
    },
    "requestFlow": {
      "notChargedNow": "You won't be charged now.",
      "venueConfirmBody": "This space is available, {{venueName}} just needs to confirm the booking. When the venue accepts, you will be sent details to finalize your reservation.",
      "messagePlaceholder": "Have any questions for {{venueName}}? Send along a message with your request.",
      "venueResponseTime": "Venue usually responds within {{time}}",
      "submitting": "Submitting...",
      "submitRequest": "Submit Request",
      "alreadySubmitted": "You've already submitted a request for this reservation. Please wait for the venue to approve your request before you can book.",
      "viewRequest": "View Request",
      "requestSentSubtitle": "<bold>{{venueName}}</bold> will reach out shortly to help finalize your booking and answer any questions.",
      "keepSearching": "Keep Searching"
    },
    "modals": {
      "cancellationPolicyTitle": "Cancellation Policy",
      "minimumSpendTitle": "Minimum Spend not met",
      "minimumSpendBody": "The items you've pre-ordered do not meet the minimum spend for this room. Any outstanding balance can be put towards on-site items. Any remaining balance by the end of the night will be added to the tab."
    }
  }
}
